/**
 * Scroll utilities module
 * Handles smooth scrolling and scroll-related effects
 */

/**
 * Smoothly scrolls to a target element or selector
 * @param {string|Element} target - CSS selector string or DOM element
 * @param {Document} doc - The document object
 */
export function smoothScrollTo(target, doc = document) {
  if (typeof target === 'string') {
    const element = doc.querySelector(target);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  } else if (target && typeof target.scrollIntoView === 'function') {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}

/**
 * Smoothly scrolls the page to the top
 * @param {Window} win - The window object
 */
export function scrollToTop(win = window) {
  win.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

/**
 * Updates the scroll progress CSS variable
 * @param {Window} win - The window object
 * @param {Document} doc - The document object
 * @returns {number} The progress value (0 to 1)
 */
export function updateScrollProgress(win = window, doc = document) {
  const scrolled = win.scrollY;
  const maxScroll = doc.documentElement.scrollHeight - win.innerHeight;
  const progress = maxScroll > 0 ? Math.min(scrolled / maxScroll, 1) : 0;
  doc.documentElement.style.setProperty('--scroll-progress', progress);
  return progress;
}

/**
 * Adds stagger animation delays to grid children
 * @param {Document} doc - The document object
 * @param {string} gridSelector - CSS selector for grids
 * @param {string} childSelector - CSS selector for children
 * @param {number} delayIncrement - Delay increment in seconds
 */
export function addStaggerAnimation(
  doc = document,
  gridSelector = '.stagger-grid',
  childSelector = '.card, .scroll-reveal',
  delayIncrement = 0.1
) {
  const grids = doc.querySelectorAll(gridSelector);
  grids.forEach((grid) => {
    const children = grid.querySelectorAll(childSelector);
    children.forEach((child, index) => {
      child.style.transitionDelay = `${index * delayIncrement}s`;
    });
  });
}
